import { Component } from "@angular/core";
import {
  faSave,
  faBroom,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CarRegistrationService } from "src/app/services/autopac/car-registration.service";
import { NotifierService } from "angular-notifier";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-car-registration",
  templateUrl: "./car-registration.component.html",
  styleUrls: ["./car-registration.component.css"],
})
export class CarRegistrationComponent {
  faSave = faSave;
  faBroom = faBroom;
  faPrint = faPrint;

  lockDoc: boolean = true;
  lockUpdate: boolean = true;

  lastDetails: any = null;

  carRegistration: FormField[] = [
    {
      type: "search",
      id: "ContractNo",
      label: "Contract number",
      required: true,
      searchEvent: true,
      searchType: "contractNumber",
      isAuto: true,
    },
    {
      type: "text",
      id: "CoeNumber",
      label: "COE number",
    },
    {
      type: "text",
      id: "InvoiceDate",
      label: "Invoice date",
      lock: true,
    },
    {
      type: "formCheckbox",
      id: "IsNumberRetention",
      label: "Tick if have number retention",
    },
    {
      type: "text",
      id: "RegistrationNumber",
      label: "Registration number",
      required: true,
    },
    {
      type: "text",
      id: "IUNumber",
      label: "IU number",
      required: true,
    },
    {
      type: "date",
      id: "RegistrationDate",
      label: "Registration date (dd/mm/yyyy)",
    },
    {
      type: "text",
      id: "CaseNumber",
      label: "Vin number",
      lock: true,
    },
    {
      type: "text",
      id: "Model",
      label: "Model",
      lock: true,
    },
    {
      type: "text",
      id: "ChasisNumber",
      label: "Chasis number",
    },
    {
      type: "text",
      id: "EngineNumber",
      label: "Engine number",
    },
    {
      type: "text",
      id: "BuyerNric",
      label: "Buyer's NRIC",
      lock: true,
    },
    {
      type: "text",
      id: "SalesConsultantName",
      label: "Sales consultant's name",
      lock: true,
    },
    {
      type: "text",
      id: "BuyerName",
      label: "Buyer's name",
    },
    {
      type: "text",
      id: "FinanceCompany",
      label: "Finance company",
      lock: true,
    },
    {
      type: "text",
      id: "CoeAmount",
      label: "",
      show: false,
    },
    {
      type: "text",
      id: "CoeDeposit",
      label: "",
      show: false,
    },
  ];

  vinSeriesChecking: FormField[] = [
    {
      type: "search",
      id: "vinNo",
      label: "Vin series",
      searchEvent: true,
      searchType: "vin",
    },
  ];

  equipmentItems: string[] = Array(12).fill("");

  constructor(
    private carRegistrationService: CarRegistrationService,
    private notifier: NotifierService,
    private datePipe: DatePipe,
  ) {}

  updateFields(event: any) {
    this.checkAllowUpdate();
    if (event.updatedValue === 3) {
      this.updateRetention();
    }
  }

  search(event: any): void {
    const contractNo = this.getField("ContractNo").value;

    this.carRegistrationService
      .getDetails(contractNo)
      .subscribe((response) => {
        this.lockDoc = false;
        for (const [key, value] of Object.entries(response.body)) {
          if (
            key === "RegistrationDate" &&
            typeof value === "string"
          ) {
            const today = new Date();
            this.getField(key).value =
              value === ""
                ? this.datePipe.transform(today, "yyyy-MM-dd")
                : this.convertDateToYYYYMMDD(value);
          } else {
            this.getField(key).value = value;
          }
        }

        this.equipmentItems = Array.from(
          { length: 12 },
          (_, index) => response.body[`DelCerDesc${index + 1}`],
        );

        this.checkAllowUpdate();
      });
  }

  searchvin(event: any): void {
    const vinNo = this.getField("vinNo").value;

    this.carRegistrationService
      .checkVinSeriesExist(vinNo)
      .subscribe((response) => {
        this.notifier.notify(
          response.code === 0 ? "success" : "error",
          response?.body.Message,
        );
      });
  }

  updateRetention(): void {
    const name = this.getField("ContractNo").value;
    const value = this.getField("IsNumberRetention").value
      ? "1"
      : "0";

    if (!name) {
      this.notifier.notify(
        "error",
        "Kindly add a valid contract number",
      );
      return;
    }

    this.carRegistrationService
      .updateRetention(name, value)
      .subscribe((response) => {
        if (response.code === 0) {
          this.notifier.notify(
            "success",
            value === "1"
              ? "Record saved successfully!"
              : "You cancelled the number retention for this contract!",
          );
        }
      });
  }

  print(): void {
    const contractNo = this.getField("ContractNo").value;

    this.carRegistrationService
      .getDeliveryCertificate(contractNo)
      .subscribe(
        (response) => {
          window.open(response.body.Name, "_blank");
        },
        (error) => {
          console.log(error);
        },
      );
  }

  update(): void {
    const payload = {
      __type: "KAPS.Model.Autopac.CrmCarRegistration",

      ...Object.fromEntries(
        this.carRegistration.map((item) => {
          if (["InvoiceDate", "RegistrationDate"].includes(item.id)) {
            return [item.id, this.convertDateToDDMMYYYY(item.value)];
          }
          return [item.id, item.value];
        }),
      ),

      Remarks: "",

      ...Object.fromEntries(
        this.equipmentItems.map((item, index) => [
          `DelCerDesc${index + 1}`,
          item || "",
        ]),
      ),

      isAutoDelCerDesc: true,
      RegrossedTaxableAmount8GST: null,
      GtsPayable8: null,
    };

    this.carRegistrationService.update(payload).subscribe({
      next: (response) => {
        this.notifier.notify("success", response.body.Message);
      },
      error: (error) => {
        console.error("Update error:", error);
      },
    });
  }

  updateFullDoc(): void {
    const contractNo = this.getField("ContractNo").value;

    this.carRegistrationService.updateFullDoc(contractNo).subscribe(
      (response) => {
        this.notifier.notify("success", "Record saved successfully!");
      },
      (error) => {
        console.log(error);
      },
    );
  }

  /* UTILITY FUNCTIONS */

  checkAllowUpdate(): void {
    this.lockUpdate = !(
      this.getField("ContractNo").value &&
      this.getField("RegistrationNumber").value &&
      this.getField("IUNumber").value
    );
  }

  clear(): void {
    this.carRegistration.forEach(
      (f) => (f.value = f.type === "formCheckbox" ? false : ""),
    );
    this.equipmentItems = Array(12).fill("");
    this.lockDoc = true;
    this.lockUpdate = true;
  }

  getField(id: string): FormField {
    const allFields: FormField[] = [
      ...this.carRegistration,
      ...this.vinSeriesChecking,
    ];
    return (
      allFields.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }

  convertDateToYYYYMMDD(dateString: string): string {
    if (!dateString) return "";

    const parts = dateString.split("/");
    if (parts.length !== 3) return dateString;

    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  }

  convertDateToDDMMYYYY(dateString: string): string | null {
    if (!dateString || !dateString.includes("-")) return null;
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  }

  trackByIndex(index: number, _item: string): number {
    return index;
  }
}
